/* eslint-disable camelcase */
import React, { useMemo } from 'react';
import { gql, useApolloClient } from '@apollo/client';
import { Desktop, Mobile } from 'app/components/Responsive';
import { ingredientTypeTextRecord } from './customIngredientsSelectDishRow.records';
import { DesktopCustomIngredientsSelect } from './Desktop';
import { MobileCustomIngredientsSelect } from './Mobile';
import { ICustomIngredientsSelectDishRowCommonProps } from './CustomIngredientsSelectDishRow.types';


const CustomIngredientsSelectDishRow = (props: ICustomIngredientsSelectDishRowCommonProps) => {
    const {
        id,
        selectedDishId,
        optionsList,
        onNextIdSelected, // ex setSelectedDishId
        environmentContext,
        disabled,
        onSubmitHandler,
        isNewLayout,
        titleRenderField = 'replaceableIngredient',
    } = props;

    const checkIsSelected = (I: string, II: string) => (I === II ? 'selected' : '');

    const client = useApolloClient();

    const data = client.readFragment({
        id: `menuDish:${selectedDishId}`,
        fragment: gql`
            fragment DISH_CUSTOM_INGREDIENTS_FRAGMENT on menuDish {
                replaceableIngredient,
                secondDishPart,
                parentId,
                category_id,

                upsell_dishes {
                    id
                    title
                    name_upsell
                    price
                    portions
                }
            }`,
    });

    const secondDishPart = useMemo(
        () => data?.secondDishPart || null,
        [data],
    );

    const replaceableIngredient = useMemo(
        () => data?.replaceableIngredient || null,
        [data],
    );

    /* SELECTORS */
    const ingredientTypeText = useMemo(
        () => {
            const additionalDishTitle = selectedDishId === null ? '' : ingredientTypeTextRecord[5];
            return titleRenderField !== 'replaceableIngredient'
                ? additionalDishTitle
                // @ts-ignore
                : ingredientTypeTextRecord[secondDishPart];
        },
        [secondDishPart, selectedDishId, titleRenderField],
    );

    return (
        <>
            <Desktop>
                {environmentContext !== 'basket' && environmentContext !== 'lp' ? (
                    <DesktopCustomIngredientsSelect
                        disabled={disabled}
                        id={id}
                        selectedDishId={selectedDishId}
                        secondDishPart={secondDishPart}
                        optionsList={optionsList}
                        checkIsSelected={checkIsSelected}
                        onNextIdSelected={onNextIdSelected}
                        ingredientTypeText={ingredientTypeText}
                        replaceableIngredient={replaceableIngredient}
                        titleRenderField={titleRenderField}
                    />
                ) : (
                    <MobileCustomIngredientsSelect
                        disabled={disabled}
                        id={id}
                        selectedDishId={selectedDishId}
                        secondDishPart={secondDishPart}
                        optionsList={optionsList}
                        checkIsSelected={checkIsSelected}
                        onNextIdSelected={onNextIdSelected}
                        ingredientTypeText={ingredientTypeText}
                        replaceableIngredient={replaceableIngredient}
                        onSubmitHandler={onSubmitHandler}
                        environmentContext={environmentContext}
                        isNewLayout={isNewLayout}
                        titleRenderField={titleRenderField}
                    />
                )}
            </Desktop>
            <Mobile>
                <MobileCustomIngredientsSelect
                    disabled={disabled}
                    id={id}
                    selectedDishId={selectedDishId}
                    secondDishPart={secondDishPart}
                    optionsList={optionsList}
                    checkIsSelected={checkIsSelected}
                    onNextIdSelected={onNextIdSelected}
                    ingredientTypeText={ingredientTypeText}
                    replaceableIngredient={replaceableIngredient}
                    onSubmitHandler={onSubmitHandler}
                    environmentContext={environmentContext}
                    isNewLayout={isNewLayout}
                    titleRenderField={titleRenderField}
                />
            </Mobile>
        </>
    );
};

export { CustomIngredientsSelectDishRow };
